var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "77px",
    viewBox: "0 0 51 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4B7D4424-11F6-4D84-B0EB-4F1DA6BD2997") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.0537429946,23.5491422 C1.11613604,25.6220556 2.01100633,27.3501049 3.49215624,28.245746 C5.73188172,22.8221715 8.69842389,15.5973247 19.0448873,8.92721809 C19.0489252,8.92461165 4.05930831,20.7739946 2.81207936,36.9291016 C2.77702233,37.3837898 4.98658144,35.5049657 4.99454836,35.4470485 C5.11830313,34.5470414 5.62352559,30.829867 6.68645383,29.5673469 C8.77954893,29.8548703 10.9159235,29.5546679 12.8298717,28.7040766 C12.8298717,28.7040766 8.4412244,28.4263592 8.48054989,28.1635445 C8.51974484,27.9007298 13.7580977,28.6753235 16.4815859,23.7280492 C13.1530169,24.7377077 11.2934842,23.3631558 11.3446883,23.0203473 C11.3957836,22.6774811 15.7074986,24.6700595 20.017621,18.5924781 C17.6533967,19.5676609 14.5186922,19.0998459 14.5781808,18.7014224 C14.6376694,18.3029988 20.017621,18.5924781 23.199383,12.7653986 C20.3733823,14.0343609 18.7498896,13.0604855 18.7498896,13.0604855 C27.3568549,11.0197867 22.7889151,0 22.7889151,0 C21.5525204,9.00500841 -5.02122503,14.7809252 3.70365585,25.6835824 C2.82408412,26.0030563 -0.457427465,22.5516772 0.0537429946,23.5491422 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-57.5%",
    y: "-85.4%",
    width: "237.6%",
    height: "222.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inspiration-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01A---Inspirations",
    transform: "translate(-165.000000, -703.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sep",
    transform: "translate(0.000000, 732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(176.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D5D9DC",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.0f867652b13dd875d1b9c08a5bc9c975.svg";
export { ForwardRef as ReactComponent };